import { openModal } from '@core/components/ModalStack';
import { ProcessPaymentModalProps } from './ProcessPaymentModal';
import { ManualPaymentModalProps } from './ManualPaymentModal';

export async function openProcessPaymentModal(props: ProcessPaymentModalProps) {
  const { ProcessPaymentModal } = await import('./ProcessPaymentModal');

  openModal(ProcessPaymentModal, props);
}

export async function openManualPaymentModal(props: ManualPaymentModalProps) {
  const { ManualPaymentModal } = await import('./ManualPaymentModal');

  openModal(ManualPaymentModal, props);
}
